(() => {
  const desktopBreakpoint = 990;
  let lastScrollPosition = window.scrollY;

  function closeDesktopMegaMenus() {
    if (window.innerWidth < desktopBreakpoint) return;

    document
      .querySelectorAll('details.mega-menu[open]')
      .forEach((menu) => {
        menu.removeAttribute('open');

        const summary = menu.querySelector('summary');

        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
      });
  }

  function initializeYuyaCarousel(carousel) {
    if (carousel.dataset.yuyaInitialized === 'true') return;

    const viewport = carousel.querySelector(
      '[data-yuya-carousel-viewport]'
    );

    const previousButton = carousel.querySelector(
      '[data-yuya-carousel-previous]'
    );

    const nextButton = carousel.querySelector(
      '[data-yuya-carousel-next]'
    );

    const cards = carousel.querySelectorAll(
      '.yuya-mega-menu__card'
    );

    /*
      Desktop:
      Bis einschließlich 4 Karten kein Slider.
      Ab 5 Karten wird der Carousel aktiviert.
    */
    if (
      !viewport ||
      !previousButton ||
      !nextButton ||
      cards.length <= 4
    ) {
      return;
    }

    carousel.dataset.yuyaInitialized = 'true';

    function getScrollDistance() {
      const firstCard = cards[0];

      const track = carousel.querySelector(
        '.yuya-mega-menu__promotions'
      );

      if (!firstCard || !track) {
        return 200;
      }

      const styles = window.getComputedStyle(track);

      const gap =
        parseFloat(styles.columnGap || styles.gap) || 0;

      return (
        firstCard.getBoundingClientRect().width +
        gap
      );
    }

    function updateButtons() {
      const maximumScroll =
        viewport.scrollWidth - viewport.clientWidth;

      previousButton.disabled =
        viewport.scrollLeft <= 2;

      nextButton.disabled =
        viewport.scrollLeft >= maximumScroll - 2;
    }

    previousButton.addEventListener('click', () => {
      viewport.scrollBy({
        left: -getScrollDistance(),
        behavior: 'smooth'
      });
    });

    nextButton.addEventListener('click', () => {
      viewport.scrollBy({
        left: getScrollDistance(),
        behavior: 'smooth'
      });
    });

    viewport.addEventListener(
      'scroll',
      updateButtons,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      updateButtons
    );

    updateButtons();
  }

  function initializeAllYuyaCarousels() {
    document
      .querySelectorAll('[data-yuya-carousel]')
      .forEach(initializeYuyaCarousel);
  }

  window.addEventListener(
    'scroll',
    () => {
      const currentScrollPosition = window.scrollY;

      if (
        Math.abs(
          currentScrollPosition -
          lastScrollPosition
        ) >= 5
      ) {
        closeDesktopMegaMenus();

        lastScrollPosition =
          currentScrollPosition;
      }
    },
    {
      passive: true
    }
  );

  window.addEventListener(
    'resize',
    closeDesktopMegaMenus
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllYuyaCarousels
    );
  } else {
    initializeAllYuyaCarousels();
  }

  document.addEventListener(
    'shopify:section:load',
    () => {
      initializeAllYuyaCarousels();
    }
  );
})();